import React, { Component } from 'react'
import { Link } from 'react-router-dom';
import logo from '../image/logo.png';
import logo_mobile from '../image/logo_mobile.png';
import logo_mengduo from '../image/mengduo/logo_mengduo.svg';
import '../config';


export default class componentName extends Component {
    constructor(props){
        super(props)
          this.state={
            isFirst:false,
            isMobile:false,
            showLine:false,
            menuNum:Number,
            navigator:[
              {
                title:'首页',
                pagePath:'/'
              },
              {
                title:'技术介绍',
                pagePath:'/technology'
              },
              {
                title:'合作案例',
                pagePath:'/cooperation'
              },
              {
                title:'解决方案',
                pagePath:'/solution'
              },
              {
                title:'产品中心',
                pagePath:'/product'
              },
              {
                title:'使用教程',
                pagePath:'/tutorial'
              },
              {
                title:'常见问题',
                pagePath:'/question'
              },
              {
                title:'关于我们',
                pagePath:'/about'
              },
              
            ],navigator_mobile:[
              {
                title:'首页',
                pagePath:'/'
              },
              {
                title:'技术介绍',
                pagePath:'/technology'
              },
              {
                title:'合作案例',
                pagePath:'/cooperation'
              },
              {
                title:'解决方案',
                pagePath:'/solution'
              },
              {
                title:'产品中心',
                pagePath:'/product'
              },
              {
                title:'关于我们',
                pagePath:'/about'
              },
              
            ]
          }
      }

      componentDidMount(){
        if(window.location.pathname==='/'){
          this.setState({
            isFirst:!this.state.isFirst
          })
        }
        let that=this
        window.addEventListener('hashchange', function() {
          console.log(window.location.hash);
          console.log("+++++"+that.state);
          if(window.location.hash=='#sectionOne'){
            console.log("往下滑"+that.state);
            that.setState({
              isFirst:true
            })
          }
          else{
            console.log("haha");
            that.setState({
              isFirst:false
            })
          }
         
        });
      }
     
      // changecolor=(index)=>{
      //   console.log(index);
      //   if(index==0){
      //     this.setState({
      //       isFirst:true,
      //       menuNum:index
      //     },()=>{
      //       console.log("++++"+this.state.menuNum);
      //     })
      //   }else{
      //     this.setState({
      //       menuNum:index,
      //       isFirst:false,
            
      //     },()=>{
      //       console.log("----"+this.state.menuNum+this.state.isFirst);
            
      //     })
      //   }
        
      // }

    render() {
        return (
            <div>
                 {global.constants.isMobile&&
                <div className="App">
                    <div className="App-header">
                    <div className="top">
                        <img src={logo_mobile} className="App-logo" alt="logo"/>
                        <Link to="/trial" className="apply" style={{textDecoration:"none"}}>申请试用</Link>
                    </div>
                    <div className="nav">
                        {
                            this.state.navigator_mobile.map((item,index)=>{
                                return(
                                    <Link to={item.pagePath} className="subNav" >{item.title}</Link>
                                );
                            })
                        }
                    </div>
                    </div>
                </div>}
                {!global.constants.isMobile&&
                <div>
                  {!this.state.isFirst&&
                    <div className="App-header">
                    <img src={global.constants.channel==="mengduo"? logo_mengduo:logo} className="App-logo" alt="logo"/>
                    {
                          this.state.navigator.map((item,index)=>{
                              return(
                                <Link to={item.pagePath} className="header-title01">{item.title}</Link>
                              );
                          })
                      }
                  </div>
                  }
                  {this.state.isFirst&&
                    <div className="App-header">
                      <img src={global.constants.channel==="mengduo"? logo_mengduo:logo} className="App-logo" alt="logo"/>
                      {
                            this.state.navigator.map((item,index)=>{
                                return(
                                    <Link to={item.pagePath} className="header-title" >{item.title}</Link>
                                );
                            })
                        }
                    </div>
                  }
                </div>}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/header.js